import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Loader2 } from "lucide-react";
import { useUpdateMentorship } from "@/lib/api/mentorships.ts";
import { useState } from "react";

interface UpdateMentorshipProps {
  mentorshipId: string;
  userId: string;
  deactivated: boolean;

  disabled?: boolean;
}

export function UpdateMentorship({
  mentorshipId,
  userId,
  deactivated,

  disabled,
}: UpdateMentorshipProps) {
  const [open, setOpen] = useState(false);
  const { mutateAsync: updateMentorship, isPending } =
    useUpdateMentorship(userId);

  const handleUpdate = async () => {
    await updateMentorship({
      mentorshipId,
      deactivated: !deactivated,
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary" disabled={disabled}>
          {deactivated ? "Reactivate" : "Deactivate"} mentorship
        </Button>
      </DialogTrigger>
      <DialogContent className="w-full max-w-lg p-0" hideCloseButton>
        <div className="p-4">
          <DialogHeader>
            <DialogTitle className="mb-1 text-2xl font-semibold">
              {deactivated
                ? "Do you want to reactivate the mentorship?"
                : "Do you want to deactivate the mentorship?"}
            </DialogTitle>
            <DialogDescription className="text-base">
              {deactivated
                ? "This will reactivate the mentorship."
                : "This will deactivate the mentorship."}
            </DialogDescription>
          </DialogHeader>
          <div className="mt-4 flex flex-row items-center gap-4">
            <Button
              className="w-full text-lg font-bold text-slate-900"
              variant="outline"
              onClick={setOpen.bind(null, false)}
              disabled={isPending}
            >
              No
            </Button>
            <Button
              className="w-full text-lg font-bold text-white"
              variant="default"
              onClick={async () => {
                await handleUpdate();
                setOpen(false);
              }}
              disabled={isPending}
            >
              {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Yes
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
